/** Cockpit leaf: intentionally has no dedicated permission gate. */
export const anomalyNavItems = [
  {
    labelKey: 'shell.nav.anomalies',
    icon: 'alert-triangle' as const,
    navKey: 'anomalies',
    to: { name: 'Anomalies' },
  },
]
